import CommercialClaim from "@/api/ClaimsNotifications/CommercialClaim";

class CommercialClaimIpr extends CommercialClaim {
  static getResourceEndpoint() {
    return '/commercial-claims-ipr';
  }
}

export default CommercialClaimIpr;
